import { Logo } from "./Logo";

export function FullScreenLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="animate-pulse-soft">
        <Logo />
      </div>
    </div>
  );
}

export function InlineLoading({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-12 text-muted-foreground">
      <div className="flex items-center gap-3">
        <span className="size-4 animate-spin rounded-full border-2 border-current border-r-transparent" />
        {label ? <span className="text-sm">{label}</span> : null}
      </div>
    </div>
  );
}
